<template>
  <footer class="shell-footer">
    <v-sheet color="primary darken-4">
      <v-container
        class="
          pt-0
          pb-4
          d-flex
          flex-column flex-sm-row
          justify-center
          align-center
          text-center
        "
      >
        <a
          class="d-flex mt-4"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="mr-4 shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
        <div class="d-flex flex-column align-start">
          <div class="white--text text-caption font-weight-light mt-4">
            {{ `© ${informations.name} ${year}.` }}
          </div>

          <span class="white--text text-caption font-weight-light">
            Todos os direitos reservados.
          </span>
        </div>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr auto;
    justify-content: space-between;

    @media screen and (min-width: 600.001px) and (max-width: 960px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:first-child {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    .btn-contact::v-deep {
      .v-btn__content {
        max-width: 100%;
        white-space: normal;
      }
    }
  }
}
</style>
